import { price as priceUtils } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { dataCellStyles } from '../utils/summaryStyles';
import SummaryPriceInformation from './SummaryPriceInformation';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cellStyles = css`
  ${dataCellStyles};

  @media (max-width: 47.9375em) {
    display: block;
    margin-left: 36px;
    max-width: 43%;

    html[dir='rtl'] & {
      margin-left: 0;
      margin-right: 36px;
    }
  }
`;
const priceStyles = css`
  display: flex;
`;
const labelStyle = css`
  margin-right: 3px;
`;
const SummaryPriceCell = _ref => {
  let {
    markup = null,
    markupTooltipId,
    seatPrice
  } = _ref;
  const {
    t
  } = useTranslation();
  const summarySeatSelectedPriceLabel = t('Product.SeatMap.Seat.Price');
  return /*#__PURE__*/_jsx("td", {
    className: cellStyles,
    children: typeof seatPrice === 'number' && /*#__PURE__*/_jsxs("div", {
      className: priceStyles,
      children: [/*#__PURE__*/_jsx("span", {
        className: labelStyle,
        children: summarySeatSelectedPriceLabel
      }), priceUtils.formatPrice(seatPrice), typeof markup === 'number' && /*#__PURE__*/_jsx(SummaryPriceInformation, {
        id: markupTooltipId,
        markup: markup,
        price: seatPrice
      })]
    })
  });
};
export default SummaryPriceCell;
//# sourceMappingURL=SummaryPriceCell.js.map